<template>
  <v-card>
    <v-container fluid>
      <v-row dense align="center" justify="end">
        <v-col class="font-weight-bold">
          Receita {{ index + 1 }}
          {{ prescription.specialControl ? " - Controle especial" : "" }}
        </v-col>

        <v-col cols="auto">
          <authorization
            permissionKey="attendance_prescription"
            can="print"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  :disabled="printLoading"
                  :loading="printLoading"
                  @click="downloadPrescription"
                  v-if="authorization || forcePrint"
                >
                  <v-icon>eva-printer-outline</v-icon>
                </v-btn>
              </template>
              <span> Imprimir </span>
            </v-tooltip>
          </authorization>

          <authorization
            v-if="allowEdit"
            permissionKey="attendance_prescription"
            can="save"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  :to="`receituario/${prescription.id}`"
                  v-if="authorization"
                  :disabled="signed"
                >
                  <v-icon>eva-edit-outline</v-icon>
                </v-btn>
              </template>

              <span> Editar </span>
            </v-tooltip>
          </authorization>

          <authorization
            v-if="allowDelete"
            permissionKey="attendance_prescription"
            can="delete"
            v-slot:default="{ authorization }"
          >
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  icon
                  :attrs="attrs"
                  v-on="on"
                  @click="deletePrescription"
                  v-if="authorization"
                  :disabled="signed"
                >
                  <v-icon>eva-trash-outline</v-icon>
                </v-btn>
              </template>

              <span> Excluir </span>
            </v-tooltip>
          </authorization>

          <v-btn icon small @click="showContent = !showContent">
            <v-icon v-if="showContent">eva-chevron-up-outline</v-icon>
            <v-icon v-else>eva-chevron-down-outline</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row dense v-show="showContent">
        <v-col>
          <v-divider />

          <v-row
            v-for="(prescriptionItems, routeName) in itemsFor"
            :key="routeName"
          >
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-capitalize">
                  {{ routeName }}
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col>
                  <PrescriptionItem
                    v-for="(prescriptionItem, index) in prescriptionItems"
                    :key="prescriptionItem.id"
                    :permitEdit="false"
                    :attendance="attendance"
                    :prescriptionItem="prescriptionItem"
                    :index="index"
                    :prescriptionId="prescription.id"
                    :disabled="signed"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <!-- <v-row v-if="!lodash.isEmpty(newMedsFor)"> -->
          <!--   <v-col> -->
          <!--     <v-row dense> -->
          <!--       <v-col class="font-weight-bold text-capitalize"> -->
          <!--         Medicações Extras -->
          <!--       </v-col> -->
          <!--     </v-row> -->
          <!---->
          <!--     <v-row no-gutters> -->
          <!--       <v-col> -->
          <!--         <PrescriptionNewMed -->
          <!--           v-for="(prescriptionNewMed, index) in newMedsFor" -->
          <!--           :key="prescriptionNewMed.id" -->
          <!--           :index="index" -->
          <!--           :permitEdit="false" -->
          <!--           :attendance="attendance" -->
          <!--           :prescriptionNewMed="prescriptionNewMed" -->
          <!--           :prescriptionId="prescription.id" -->
          <!--           :disabled="signed" -->
          <!--         /> -->
          <!--       </v-col> -->
          <!--     </v-row> -->
          <!--   </v-col> -->
          <!-- </v-row> -->

          <v-row v-if="!lodash.isEmpty(guidancesFor)">
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold text-capitalize">
                  Orientações
                </v-col>
              </v-row>

              <v-row no-gutters>
                <v-col>
                  <PrescriptionGuidance
                    v-for="(prescriptionGuidance, index) in guidancesFor"
                    :key="prescriptionGuidance.id"
                    :index="index"
                    :permitEdit="false"
                    :attendance="attendance"
                    :prescriptionGuidance="prescriptionGuidance"
                    :prescriptionId="prescription.id"
                    :disabled="signed"
                  />
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import PrescriptionItem from "@/components/prescription/item.vue";
import PrescriptionGuidance from "@/components/prescription/guidance.vue";
//import PrescriptionNewMed from "@/components/prescription/new_med.vue";

import GET_PRESCRIPTION from "@/graphql/prescription/prescription.gql";
export default {
  name: "PrescriptionListItem",
  props: {
    attendance: Object,
    prescription: Object,
    index: Number,
    refreshList: Function,
    allowEdit: {
      type: Boolean,
      default: true,
    },
    allowDelete: {
      type: Boolean,
      default: true,
    },
    forcePrint: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PrescriptionItem,
    PrescriptionGuidance,
    //PrescriptionNewMed,
  },
  data() {
    return {
      printLoading: false,
      showContent: true,
    };
  },
  apollo: {
    prescription: {
      query: GET_PRESCRIPTION,
      variables() {
        return {
          prescriptionId: this.prescriptionId,
        };
      },
      skip() {
        return !this.prescriptionId;
      },
      result({ data }) {
        this.specialControl = data.prescription.specialControl;
        this.prescription = data.prescription
      },
      pollInterval: 20000,
    },
  },
  computed: {
    itemsFor() {
      let items = this.lodash.orderBy(
        this.prescription.items,
        ["createdAt"],
        ["desc"]
      );
      return this.lodash.groupBy(items, "applicationRoute.name");
    },
    guidancesFor() {
      return this.lodash.orderBy(
        this.prescription.guidances,
        ["createdAt"],
        ["desc"]
      );
    },
    newMedsFor() {
      return this.lodash.orderBy(
        this.prescription.newMeds,
        ["createdAt"],
        ["desc"]
      );
    },
    signed() {
      return this.prescription.lastEsign.status !== "editable";
    },
  },
  methods: {
    deletePrescription() {
      if (confirm("Você realmente deseja deletar essa prescrição?")) {
        this.apolloMutate({
          mutation: require("@/graphql/prescription/delete_prescription.gql"),
          variables: {
            prescriptionId: this.prescription.id,
          },
        }).then(() => {
          this.refreshList();
          this.$store.dispatch("createNotification", {
            message: "Prescrição deletada com sucesso.",
            type: "success",
          });
        });
      }
    },
    async generatePreview() {
      await this.apolloMutate({
        mutation: require("@/graphql/esign/generate_preview.gql"),
        variables: {
          esignId: this.prescription.lastEsign.id,
          dynamicForm: true,
          examAppraisal: true
        },
       });
    },
    async downloadPrescription() {
      this.printLoading = true;
      await this.generatePreview();
      await this.refreshList();
      //await this.$store.dispatch("authentication/refreshToken")

      //if (this.prescription.lastEsign.status === "signed") {
      const file_url = this.prescription.lastEsign.fileUrl;

      await window.open(`${process.env.VUE_APP_BASE_URL}${file_url}`, "_blank");
      // } else {
      //   this.$store.dispatch("createNotification", {
      //     message: "É necessário assinar antes de imprimir.",
      //     type: "error",
      //   });
      // }

      this.printLoading = false;
    },
  },
};
</script>

<style lang="scss" scoped></style>
